import styles from './RegisterBtnManager.module.scss';
import { PATHS } from 'Libraries/routes.library';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@spinwise/spinwise-core';
import { t } from 'i18next';
import { LinkHandler } from '../../LinkHandler/LinkHandler';
import useShowAuthButtons from 'Hooks/useShowAuthButtons';

export interface IButtonManager<T> {
  Component: T | any;
  propsComponent?: any;
  onClick?: () => any;
  componentLabel?: boolean;
}
const RegisterBtnManager = ({ Component, propsComponent, onClick }: IButtonManager<any>) => {
  const reg_type = useSelector((state: IApplicationState) => state.globalReducer.geo.reg_type);
  const showRegisterButton = useShowAuthButtons();

  const getTypeLabel = (isPnp?: boolean) => {
    let label = isPnp ? 'pnp' : reg_type ?? 'paynplay_t';
    return t(`${label}.${propsComponent.label}`);
  };

  if (propsComponent?.disabledLink) {
    return (
      <div className={styles.signUpBtnWrapper}>
        <Component
          {...propsComponent}
          label={propsComponent.componentLabel ? propsComponent.label : getTypeLabel()}
          onClick={onClick}
        />
      </div>
    );
  }

  if (!showRegisterButton) return null;

  return (
    <>
      <LinkHandler className={styles.signUpBtnWrapper} href={PATHS.REGISTER} shallow={true}>
        <Component
          {...propsComponent}
          label={propsComponent?.componentLabel ? propsComponent?.label : getTypeLabel()}
          onClick={onClick}
        ></Component>
      </LinkHandler>
    </>
  );
};
export default RegisterBtnManager;
